import Utils from "./functionTools";
class GoPage {
  constructor(context) {
    this.Vue = context;
    this.skipFlag = Utils.judgeVersion("6.8.0");
  }
  jump(jumpInfo = { path: "", query: {} }) {
    if (!this.skipFlag && !Utils.getUrlParam("isMiniProgram")) {
      const state = Object.assign({
        url: `${window.location.href.split("#")[0]}#${
          jumpInfo.path
        }?${this.Vue.$qs.stringify(jumpInfo.query)}`,
        title: jumpInfo.query.title || "",
        isBackRefresh: jumpInfo.query.isBackRefresh || true
      });
      this.Vue.jsbridge.call("frameShowPage", state);
    } else {
      this.Vue.$router.push({
        path: jumpInfo.path,
        query: jumpInfo.query
      });
    }
  }
  back(backInfo = {}) {
    if (!this.skipFlag) {
      this.Vue.jsbridge.call("frameGoBack", {
        isBackRefresh: backInfo.isBackRefresh || true
      });
    } else {
      this.Vue.$router.back(backInfo.pageCount || -1);
    }
  }
}
export { GoPage };



// WEBPACK FOOTER //
// ./src/starcharge/utils/goPage.js